import * as React from "react";
const SvgArrowCollspse = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 4, viewBox: "0 0 7 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.46387 0L6.92797 3.75H-0.000234365L3.46387 0Z", fill: "black" }));
export default SvgArrowCollspse;
